import React from 'react'
import { Link } from 'react-router-dom'
import * as paths from 'src/routes/paths'
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Box,
  Button,
  Divider,
  LinearProgress,
} from '@material-ui/core'
import {
  AttachMoney,
  People,
  LocalOffer,
  Warning,
  ArrowUpward,
  ArrowDownward,
  CardGiftcard,
} from '@material-ui/icons'
import useStyles from './styles'

const RutaAutecoDashboardContainer = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Box mb={3}>
        <Typography variant="h5" gutterBottom style={{ fontWeight: 500 }}>
          Ruta Auteco
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.card}>
            <Box className={classes.iconBox}>
              <AttachMoney className={classes.icon} />
            </Box>
            <CardContent>
              <Typography variant="subtitle2">Total Recompensas</Typography>
              <Typography variant="h6" style={{ marginTop: '8px', fontWeight: 500 }}>$4,000,000</Typography>
              <Box className={classes.statsBox}>
                <ArrowUpward className={classes.statsIcon} />
                <Typography variant="caption">+15% vs mes anterior</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.card}>
            <Box className={classes.iconBox}>
              <People className={classes.icon} />
            </Box>
            <CardContent>
              <Typography variant="subtitle2">Vendedores Activos</Typography>
              <Typography variant="h6" style={{ marginTop: '8px', fontWeight: 500 }}>124</Typography>
              <Box className={classes.statsBox}>
                <ArrowUpward className={classes.statsIcon} />
                <Typography variant="caption">+5% vs mes anterior</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Link to={paths.RUTA_PRODUCTOS_PARTICIPANTES} style={{ textDecoration: 'none' }}>
            <Card className={classes.card} style={{ cursor: 'pointer' }}>
              <Box className={classes.iconBox}>
                <LocalOffer className={classes.icon} />
              </Box>
              <CardContent>
                <Typography variant="subtitle2">Productos Participantes</Typography>
                <Typography variant="h6" style={{ marginTop: '8px', fontWeight: 500 }}>45</Typography>
                <Box className={classes.statsBox}>
                  <ArrowDownward className={classes.statsIconDown} />
                  <Typography variant="caption">-2% vs mes anterior</Typography>
                </Box>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Link to={paths.RUTA_PRODUCTOS_RECOMPENSAS} style={{ textDecoration: 'none' }}>
            <Card className={classes.card} style={{ cursor: 'pointer' }}>
              <Box className={classes.iconBox}>
                <CardGiftcard className={classes.icon} />
              </Box>
              <CardContent>
                <Typography variant="subtitle2">Productos - Recompensas</Typography>
                <Typography variant="h6" style={{ marginTop: '8px', fontWeight: 500 }}>32</Typography>
                <Box className={classes.statsBox}>
                  <ArrowUpward className={classes.statsIcon} />
                  <Typography variant="caption">+8% vs mes anterior</Typography>
                </Box>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.cardWarning}>
            <Box className={classes.iconBoxWarning}>
              <Warning className={classes.icon} />
            </Box>
            <CardContent>
              <Typography variant="subtitle2">Anomalías en Ventas</Typography>
              <Typography variant="h6" style={{ marginTop: '8px', fontWeight: 500 }}>5</Typography>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                className={classes.button}
                fullWidth
              >
                Revisar
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Segunda fila - Estado de pagos */}
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography variant="subtitle1" style={{ fontWeight: 500 }} gutterBottom>
              Estado de Pagos
            </Typography>
            <Divider className={classes.divider} />
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2">
                  Fecha último pago: 21 de octubre
                </Typography>
                <Typography variant="body2">
                  Próximo pago: Viernes 1 nov
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" gutterBottom>
                  Progreso del período
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={90}
                  color="primary"
                />
                <Typography variant="caption" align="right" style={{ display: 'block', marginTop: '4px' }}>
                  Faltan: 1 día 2h
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default RutaAutecoDashboardContainer
